import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as interfaceActions from '../actions/interfaceActions';

const initState = {
  currentStep: 0,
  formFields: {},
  fieldsDisable: {
    startSectionDisable: false,
    fourSectionDisable: false,
  },
  // autoFillFieldsDisabledForStep1:false,
  // attemptAutoDetectData:1 // можно всего 1 раз  удачно определить номер
};

const currentStep = handleActions(
  {
    [interfaceActions.setStep]: (state, { payload }) => {
      localStorage['add_vehicle_interface_settings'] = JSON.stringify(payload);
      return payload;
    },
  },
  localStorage['add_vehicle_interface_settings']
    ? JSON.parse(localStorage['add_vehicle_interface_settings'])
    : initState.currentStep
);

const fields = handleActions(
  {
    [interfaceActions.setField]: (state, { payload }) => {
      localStorage['add_vehicle_forms'] = JSON.stringify({
        ...state,
        ...payload,
      });
      return { ...state, ...payload };
    },
    [interfaceActions.removeFields]: (state, { payload }) => {
      payload.map(field => delete state[field]);
      localStorage['add_vehicle_forms'] = JSON.stringify({ ...state });
      return { ...state };
    },
    [interfaceActions.resetFormFieldsState]: () => initState.formFields,
  },
  localStorage['add_vehicle_forms']
    ? JSON.parse(localStorage['add_vehicle_forms'])
    : initState.formFields
);

const fieldsDisable = handleActions(
  {
    [interfaceActions.fillRegisterSignFields]: (state, _action) => {
      localStorage['add_vehicle_forms_disabled_fields'] = JSON.stringify({
        ...state,
        startSectionDisable: !state.startSectionDisable,
      });
      return { ...state, startSectionDisable: !state.startSectionDisable };
    },

    [interfaceActions.resetFieldsDisableState]: () => initState.fieldsDisable,
  },
  localStorage['add_vehicle_forms_disabled_fields']
    ? JSON.parse(localStorage['add_vehicle_forms_disabled_fields'])
    : initState.fieldsDisable
);

export const interfaceSettings = combineReducers({
  currentStep,
  fields,
  fieldsDisable,
});
